import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Parallax } from 'react-parallax';

import Social from './Social';
import Number from './Number';

import WaveSurfer from 'wavesurfer.js';

import '../css/App.css';

import logo from '../img/logo.gif';
import logoMSD from '../img/logo-msd.gif';

import quote from '../img/quote.png';
import Map from './Map';
import CountUp from './CountUp';
import Cloud from './Cloud';
import Grid from './Grid';

import i from '../img/i.svg';

import graph1 from '../img/graph1.svg';
import graph2 from '../img/graph2.svg';
import graph3 from '../img/graph3.svg';
import graph4 from '../img/graph4.svg';

import bg1 from '../img/hawa.jpg';
import bg2 from '../img/loise.jpg';
import bg3 from '../img/agnes.jpg';

import section3quote from '../img/quote1.png';
import section8quote from '../img/quote2.png';
import section13quote from '../img/quote3.png';

import guy from '../img/guy.png';

import country1 from '../img/country1.png';
import country2 from '../img/country2.png';
import country3 from '../img/country3.png';
import country4 from '../img/country4.png';
import country5 from '../img/country5.png';

import africa from '../img/africa.svg';

import appStore from '../img/app-store.png';
import quoteSingleWhite from '../img/quote-white.png';

import logo1 from '../img/logo1.png';
import logo2 from '../img/logo2.png';
import logo3 from '../img/logo3.png';
import logo4 from '../img/logo4.png';
import logo5 from '../img/logo5.png';
import logo6 from '../img/logo6.png';
import logo7 from '../img/logo7.png';
import logo8 from '../img/logo8.png';
import logo9 from '../img/logo9.png';
import logo10 from '../img/logo10.png';
import logo11 from '../img/logo11.png';
import logo12 from '../img/almata-logo.jpg';


const MFM = true;

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrolled: false,
      playing: false,
      playing2: false,
      playing3: false,
    };

    this.countup1 = false;
    this.count = false;
    this.mapplay = false;

    this.number1 = false;
    this.number2 = false;
    this.number3 = false;
    this.number4 = false;
    this.number5 = false;

    this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    this.wavesurfer = null;
    this.wavesurfer2 = null;
    this.wavesurfer3 = null;

    this.section3Height = 0;
    this.section8Height = 0;
    this.section13Height = 0;


    if(MFM) {
      this.MERCK = "Merck";
      this.NAME = "Merck for Mothers";
      this.BASE_URL = "http://reports.merckformothers.com/";
      this.TITLE = "Maternal health will be mobilized & these innovations are helping to save mothers’ lives around the world. Read the latest in the @MerckforMothers interactive report.";
      this.TWITTER_TITLE = "Maternal health will be mobilized & these innovations are helping to save mothers’ lives around the world. Read the latest in the @MerckforMothers interactive report.";
    } else {
      this.MERCK = "MSD";
      this.NAME = "MSD for Mothers";
      this.BASE_URL = "http://reports.msdformothers.com/";
      this.TITLE = "Maternal health will be mobilized & these innovations are helping to save mothers’ lives around the world. Read the latest in the @MSDforMothers interactive report.";
      this.TWITTER_TITLE = "Maternal health will be mobilized & these innovations are helping to save mothers’ lives around the world. Read the latest in the @MSDforMothers interactive report.";
    }


    this._scroll = this._scroll.bind(this);
    this._resize = this._resize.bind(this);
    this._play = this._play.bind(this);
    this._play2 = this._play2.bind(this);
    this._play3 = this._play3.bind(this);
  }
  componentDidMount() {
    window.scroll(0,0);
    window.addEventListener("scroll", this._scroll, false);
    //window.addEventListener("resize", this._resize, false);


    if(window.innerWidth >= 800) {
      this.section3Height = this.refs.section3.offsetHeight;
      this.refs.section3.style.height = this.section3Height+window.innerHeight + "px";
      this.refs.section3quote.style.top = this.section3Height + "px";

      this.section8Height = this.refs.section8.offsetHeight;
      this.refs.section8.style.height = this.section8Height+window.innerHeight + "px";
      this.refs.section8quote.style.top = this.section8Height + "px";

      this.section13Height = this.refs.section13.offsetHeight;
      this.refs.section13.style.height = this.section13Height+window.innerHeight + "px";
      this.refs.section13quote.style.top = this.section13Height + "px";
    } else {
      this.refs.countUp.start();
      this.refs.cloud.start();
      //this.refs.number2.start();
      //this.refs.number3.start();
      //this.refs.number4.start();
      //this.refs.number5.start();
    }



    if(!this.isIE11) {
      this.wavesurfer = WaveSurfer.create({
          container: '#waveform',
          waveColor: '#ccc',
          progressColor: '#10887D',
          barWidth: 3
      });

      this.wavesurfer2 = WaveSurfer.create({
          container: '#waveform2',
          waveColor: '#ccc',
          progressColor: '#10887D',
          barWidth: 3
      });

      this.wavesurfer3 = WaveSurfer.create({
          container: '#waveform3',
          waveColor: '#ccc',
          progressColor: '#10887D',
          barWidth: 3
      });

      this.wavesurfer.load(process.env.PUBLIC_URL+"linda.mp3");
      this.wavesurfer2.load(process.env.PUBLIC_URL+"sumi.mp3");
      this.wavesurfer3.load(process.env.PUBLIC_URL+"patty.mp3");
    }

  }
  render() {
    return (
      <div className="app">
        <div className="header"><a href={MFM ? "http://www.merckformothers.com" : "http://www.msdformothers.com"}><img src={MFM ? logo : logoMSD} /></a></div>
        <div className={this.state.scrolled ? "arrow bounce hide" : "arrow bounce"} />
        <div id="section1" className="flex double">
          <div className="section1-social"><Social pageSection="Website" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL+"1.html"} /></div>
          <div ref="circle" className="circle flex">
            <div>
              How mobile tech is mobilizing maternal health

              <small>A digital report by {this.MERCK} for Mothers</small>
            </div>
          </div>
        </div>
        <div id="section2" ref="section2" className="top-pad">
            <div className="section-inner p-fade">
              <p><span ref="two" className="two">Two minutes</span> <span ref="rest1" className="rest">... the amount of time that it takes to brush your teeth or put on your socks and shoes. That is how often a mother dies from complications related to pregnancy and childbirth.  Two minutes.  It's shocking but true.</span></p>
              <p><span ref="rest2" className="rest">What's even more unsettling is that the vast majority of these deaths are preventable. The difference between life and the loss of it depends on both mothers and medical teams having access to the right information and resources at the right time. That's why digital innovation holds such promise for maternal health.</span></p>
              <p><span ref="rest3" className="rest">The same technology that makes it easy to send texts and take selfies has the power to democratize information and help deliver quality maternity care and contraceptive services to moms around the world &mdash; no matter how remote their location or how small their savings accounts.</span></p>
              <p><span ref="rest4" className="rest">This revolution is already underway. A new wave of smart, innovative apps and digital platforms is empowering doctors, nurses, midwives, mothers and babies from the most far-flung corners of the planet to the busiest hospitals in the biggest cities.</span></p>
              <p><span ref="rest5" className="rest">Follow us as we take a look at some of the most exciting digital innovations in maternal health and meet the social entrepreneurs who are empowering women with mobile solutions.</span></p>
            </div>
          <div ref="expanded" className="section-inner-expanded">
            <Fade left><div className="quote"><img src={quote} alt="quote" /></div></Fade>
            <Fade bottom>
              <div className="quote-text">
                <p>"Digital innovation has revolutionized our world, and it can do the same for maternal health, ensuring that every mother no matter her color, creed, country or care provider has access to the same information and services. But this won't happen on its own. It needs restless innovators with an appetite for risk who are willing to fail fast, learn faster, adopt quickly and drive for scale. That's why we're here."</p>
                <p>Dr. Mary-Ann Etiebet, Lead & Executive Director of {this.MERCK} for Mothers</p>
              </div>
            </Fade>
            <Fade right>
              <div className="quote quote-reverse"><img src={quote} alt="quote" /></div>
            </Fade>
          </div>
        </div>
        <div ref="section3" id="section3">
          <div className="bg"></div>
          <div ref="section3quote" className="section3-quote"><img src={section3quote} /></div>
          <div ref="section3_left" className="section3-left">
            <div className="section3-inner">
              <h1>Harnessing smartphones for safer deliveries: The Safe Delivery App</h1>

              <h3>Mitike Birhanu was seconds from becoming a statistic.</h3>

              <p>Her labor had begun early in the morning, when shooting pains had run down her back with such intensity that she had asked her dad to call for an ambulance. Unable to locate one, he had slid her onto a stretcher and carried her to the local clinic.</p>

              <p>There, her son was born without complications but the second of her twins got stuck during delivery. Birhanu passed out from the pain. The midwife, Yane Ababaw, was able to coax the baby out, but it emerged in a lifeless state — breathless, limp and as unconscious as its mother in the bed.</p>

              <p>Every year upwards of 13,000 women and 100,000 newborn babies die in Ethiopia just like this. That number is disproportionately weighted toward women outside of cities, such as Birhanu who lives in the rural district of Gimbi in the west of the country.</p>

              <p>But Ababaw didn't panic. Instead, she pulled out her smartphone and opened the Safe Delivery App, which helped her quickly diagnose the problem and gave her step-by-step guidelines to perform a treatment. She placed an Ambu Bag over the mouth of the baby, whose lungs began to fill with air. The baby coughed and came to life.</p>

              <p>The app helped Ababaw diagnose and treat Birhanu as well — on the fly, when there was no time to spare. Mother, daughter and son returned home in good health a few days later.</p>

              <p>This is what digital innovation looks like — simple, effective, affordable and accessible to the masses, no matter where they live.</p>

              <p>Since its launch in April 2015, the Safe Delivery App has been downloaded by more than 47,000 users and has spread to more than 40 countries, from India to Ghana to Kenya, Myanmar and South Africa.</p>

              <p>The app was designed by Denmark's Maternity Foundation together with the University of Copenhagen and the University of Southern Denmark and with support from {this.MERCK} for Mothers and the Bill & Melinda Gates Foundation.</p>

              <p>It's free to download and can be pre-installed so that providers can watch the animated instruction videos and read the action cards and drug lists whether or not they have WiFi.</p>

              <p>Randomized controlled trials have found that the app lifts practical skills by a total of 172% among care providers, and leads to improved confidence and competence on the job and a hunger for ongoing education and growth.</p>

              <p>"Our goal is for the Safe Delivery App to become the standard training tool for midwives in low- and middle-income countries," says Anna Frellsen, CEO of Maternity Foundation. "This way, we can help empower all midwives to better handle emergencies during childbirth — even at the most remote health clinics in Sub-Saharan Africa and Southeast Asia."</p>
            </div>
          </div>
          <div className="social-bottom"><Social pageSection="SDA" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL+'2.html'} /></div>
        </div>

        <div id="section4" className="almost-full">
          <Parallax bgImage={bg1} strength={200} >
            <div className="section-full flex">
                <div className="inner">
                  <h1>Hawa Abdul-Ghafoor</h1>
                  <h3>Clinical officer at Hola Referral Hospital in Tana River County, Kenya</h3>
                  <p className="quote-single"><img src={quoteSingleWhite} alt="Quote" /></p>
                  <p className="italic">A mother had just delivered her baby when I heard a nurse call for help. It was a retained placenta. I took out my phone, opened the Safe Delivery app and looked up what to do.</p>
                  <p className="italic">The medical officer was saying they were going to take her to the operating theater &mdash; but I had reviewed the steps and so I said, "Let's try this." And I succeeded. I removed the placenta and the mother didn't have to go for the C-section.</p>
                  <p className="italic">I don't think I would have had the confidence to try it if I didn't have the app. Afterward, I showed all the nurses the Safe Delivery app and they were like, "Wow, we really need this."</p>
                  <p className="quote-single quote-reverse"><img src={quoteSingleWhite} alt="Quote" /></p>

                </div>

                {/*<div className="social-bottom"><Social mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL+'3.html'} /></div> */}
            </div>
          </Parallax>
        </div>
        <div id="section5" ref="section5" className="bg-purple top-pad">
          <div className="inner">
            <h1 ref="info0">The Safe Delivery App is being used in more than 40 Countries</h1>
            <div className="img-pad">
              <div ref="info1" className="row">
                <div className="cell cell70">
                  <CountUp ref="countUp" />
                  <div className="cell yellow"><br />projected number of downloads by 2020</div>
                </div>
                <div className="cell cell30">
                  <Cloud ref="cloud" play={this.state.number1} />
                  <div className="cell">downloads across 40 low and middle-income countries</div>
                </div>
              </div>
              <div ref="info3" className="row map">
                <Map ref="mapsection" />
              </div>
            </div>
            <Fade><h1 ref="info4">Top 5 Countries Using the App:</h1></Fade>

            <Fade left cascade>
            <div ref="info5" className="countries">
              <img src={country1} alt="" />
              <img src={country2} alt="" />
              <img src={country3} alt="" />
              <img src={country4} alt="" />
              <img src={country5} alt="" />
            </div>
            </Fade>

            <Fade>
              <div ref="info6" className="app-store"><a href="https://itunes.apple.com/us/app/safe-delivery/id985603707?mt=8"><img src={appStore} alt="Apple App Store" /></a></div>
            </Fade>


          </div>
          <div className="social-bottom"><Social pageSection="SDA Top Countries" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL+'3.html'} /></div>
        </div>
        <div ref="section6" id="section6">
          <div ref="pink" className="bg"></div>
          <div className="section6-right">
            <div className="section6-inner">
              <h1>Nneka Mobisson</h1>
              <h3>A tech leader shaping the future of maternal health solutions</h3>

              <p>At age 53, Nneka Mobisson's father survived a massive stroke. The after-effects were severe, however, and he struggled to cope in the absence of adequate medical advice and support. When he died shortly thereafter, Mobisson couldn't shake the feeling that it shouldn't have happened — that if her father had had regular access to a proper team of providers, he would still be alive. And that his story was sadly endemic of a larger narrative sweeping across her native Nigeria and all of Sub-Saharan Africa.</p>

              <p>"The fact is, millions of people in Africa are dying too early because they don't have access to the care they need," she says. </p>

              <p>After her dad's death, she set out to stop that. Her solution was mDoc, a mobile and web platform that connects patients to the medical support they need and ensures that they receive optimal care, anytime, anywhere. With mDoc, patients can receive accurate medical information at the click of a button. They can store their health records and connect with a virtual doctor or health coach who can help them achieve lifestyle modifications such as losing weight or taking their medications regularly.</p>

              <p>Think of it as a command central for your health, right in your pocket.</p>

              <p>"I wanted to make a difference and address this problem that has largely been ignored," Mobisson says. "At mDoc we believe that we can help hundreds of thousands of people live healthier, happier and fuller lives and ensure that they have access to quality care that would otherwise elude them."</p>

              <p>Mobisson was born to a Nigerian dad and an American mom and grew up straddling both worlds. She spent most of her childhood in Nigeria but headed west for a Bachelor's in Mechanical Engineering from MIT, a Masters in Public Health from Emory University, and an MD and MBA from Yale. </p>

              <p>She then embarked on an equally distinguished professional career. She helped develop African healthcare strategies for the World Bank and global healthcare strategies for McKinsey & Co. She trained as a pediatrician and served as Executive Director for the Africa Region at Institute for Healthcare Improvement (IHI), where she led efforts to build more robust and sustainable healthcare delivery systems across Africa.</p>

              <p>But of all those experiences, one of the most formative came as an unpaid intern at a nonprofit called AHEAD in Tanzania, where she worked on immunization campaigns and HIV education. The operating room at the local maternity hospital had no electricity at the time; surgeons performed surgery by kerosene lamp.</p>

              <p>Mobisson used her engineering skills to help install solar panels on the hospital roof for proper lighting inside. </p>

              <p>"Even though I had been exposed to health care inadequacies in my country, the experience in Tanzania highlighted for me the tremendous need for improvement," she says, "and how new technologies can help bridge the gap." </p>

              <p>"mDoc is a platform for all people, including mothers. It focuses particularly on patients with non-communicable diseases (NCDs), such as hypertension and diabetes, which are one of the biggest threats to pregnancy and are on the rise globally, especially in developing countries like Nigeria.  It is one of the locally-based organizations {this.MERCK} for Mothers is potentially partnering with when exploring how technology can better engage pregnant women in patient-centered quality of care improvement efforts."</p>

              <p>"Every woman should have the right to make informed decisions about her health and the manner in which she receives healthcare at the time and place of her choosing," says Mobisson. "At mDoc we are working hard to help facilitate this so that more women and more mothers are living healthier, happier lives. Our entire society stands to gain from this."</p>

            </div>
          </div>

          <div className="social-bottom"><Social pageSection="Nneka Mobisson" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL+'4.html'} color="black" /></div>
        </div>
        <div id="section7" ref="section7" className="audio-section linda">
          <a name="audio1"></a>
            <div ref="audio1" className="inner inner-black">
              <h1>Dr. Linda Bartlett on Project iDeliver</h1>
              <p><em>An Interview with Mark Allen, Director of Strategic Partnerships and Digital Lead at {this.MERCK} for Mothers</em></p>
              <p>Dr. Linda Bartlett of Johns Hopkins Bloomberg School of Public Health on Project iDeliver, a digital tool that supports providers in offering women better care, and how such sustainable technologies are transforming the global maternal health space.</p>

            </div>
            <div className={this.state.playing ? "audio audio-open" : "audio"}>
              <div id="waveform"></div>
            </div>

            {
              this.isIE11 ?
                  <div className="audio-player">
                    <audio controls>
                      <source src={process.env.PUBLIC_URL+"linda.mp3"} type="audio/mpeg" />
                    </audio>
                  </div>
                  :
                  <div className="play">{this.state.playing ? <button onClick={this._play}>Pause</button> : <button onClick={this._play}>Play</button>}</div>
            }

            <div className="social-bottom"><Social pageSection="Linda Bartlett" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} color="black" url={this.BASE_URL + "#audio1"} /></div>
        </div>
        <div ref="section8" id="section8">
          <div className="bg"></div>
          <div ref="section8quote" className="section3-quote"><img src={section8quote} /></div>

          <div ref="section8_left" className="section3-left">
            <div className="section3-inner">
              <h1>Using Data to revolutionize family planning for everyone, everywhere: NIVI</h1>

              <p>Nivi is set to change the world with a simple, startling premise: Anyone with a mobile phone can have access to reliable and accurate family planning (no data plan required). </p>

              <p>The idea was spawned by Ben Bellows and Eric Green, two public health researchers by day but tech enthusiasts at heart. Their idea? To leverage technology to bridge the information gap that exists for women in emerging markets when it comes to their health. </p>
              <p>The hard reality is that many women in need of accurate family planning information live in areas where misinformation is omnipresent. Many women can't talk to their parents or friends because "family planning" is still a taboo topic. And if you are one of the privileged few with a computer, Internet is spotty and unreliable, making research almost impossible. </p>

              <p>In 2015, Ben and Eric teamed up with Sidd Goyal, a Boston-based tech entrepreneur and soon-after, with some funding help from {this.MERCK} for Mothers, Nivi was launched in Kenya. </p>

              <p>Since Nivi's launch, the team has rapidly changed their platform to keep up with changing technology. "Nivi was first focused on recommending family planning methods via an Interactive Voice Response (an automated screening algorithm)," remembers Sidd. </p>

              <p>"The team quickly learned that texting is the best and quickest way to start a conversation, so we developed AskNivi, an intelligent chatbot that provides women with the answers they need and can direct them to various reproductive health services."</p>

              <p>AskNivi has conversations with women who are curious about birth control, instead of just telling them about it. Wherever a woman may be on their personal reproductive health journey – no kids, a few kids, or perhaps is ready to stop having children altogether – AskNivi is able to engage them and offer them help. </p>

              <p>All a woman needs is a phone. </p>

              <p>In turn, Nivi gains real time, on demand insights including demographics, contraceptive use and preference, as well as obstacles in getting birth control, among other findings.  This information can help clinics, governments, medical providers, non-profits, and others dedicated to public health create more effective family planning promotion, development, production and resources. </p>

              <p>The response in Kenya has been so robust, the team is planning to launch into other emerging markets. "Over 35,000 women have accessed Nivi to date, and we've been able to reach these women at an amazingly low cost," says Sidd.  "We've navigated  a lot of the challenges in working in settings with imperfect information while being able to introduce our product to women who are not accustomed to accessing high quality health information via their mobile phone. I'd say that's been our biggest accomplishment to date - the ability to make that vision of real-time, personalized information about your health a reality."</p>

              <p>They're just getting started. </p>
            </div>
          </div>
          <div className="social-bottom"><Social pageSection="Nivi" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL + '5.html'} /></div>
        </div>

        <div id="section9" className="almost-full">
          <Parallax bgImage={bg2} strength={100} >
            <div className="section-full flex">
              <div className="inner">
                <h1>Loise Kamua</h1>
                <h3>22 yr-old student in Nairobi who discovered Nivi on Facebook</h3>
                <p className="quote-single"><img src={quoteSingleWhite} alt="Quote" /></p>
                <p className="italic">I didn't know anything about contraceptives — anything. I just wanted to know. I didn't have anyone else to ask. I can't ask my parents, I can't ask my friends. I didn't want to ask my doctor. So, when I saw it I was excited, because I knew at least now I can ask someone who won't judge me. Young people need a service like Nivi.</p>
                <p className="quote-single quote-reverse"><img src={quoteSingleWhite} alt="Quote" /></p>
              </div>

            </div>
          </Parallax>
        </div>
        <div ref="section10" id="section10" className="bg-purple top-pad">
          <div className="inner">
            <Fade bottom><h1>HOW NIVI HELPS MOTHERS IN NEED</h1></Fade>
          </div>

          <div className="inner">
            <div className="list clearfix">
              <div className="fourth">
                <div className="fourth-image">
                  <div ref="fourth1" className="fourth-image-inner">
                    <div className="fourth-top1">34,081</div>
                    <div className="fourth-label">users</div>
                    <div className="fourth-graph1"><img src={graph1} /></div>
                  </div>
                </div>
                <p>She calls AskNivi and receives answers to her questions about contraception</p>
              </div>
              <div className="fourth">
                <div className="fourth-image">
                  <div ref="fourth2" className="fourth-image-inner">
                    <div className="fourth-top2">5,235</div>
                    <div className="fourth-label">Family Planning (FP) Referrals</div>
                    <div className="fourth-graph2"><img src={graph2} /></div>
                  </div>
                </div>
                <p>She receives a recommendation on where to seek her preferred FP method</p>
              </div>
              <div className="fourth">
                <div className="fourth-image">
                  <div ref="fourth3" className="fourth-image-inner">
                    <div className="fourth-top3">1,652</div>
                    <div className="fourth-label">Redeemed FP Users</div>
                    <div className="fourth-graph3"><img src={graph3} /></div>
                  </div>
                </div>
                <p>She goes to the clinic to redeem her family planning method</p>
              </div>
              <div className="fourth">
                <div className="fourth-image">
                  <div ref="fourth4" className="fourth-image-inner">
                    <div className="fourth-top4">1,248</div>
                    <div className="fourth-label">Users who provide feedback</div>
                    <div className="fourth-graph4"><img src={graph4} /></div>
                  </div>
                </div>
                <p>She rates her experience</p>
              </div>
            </div>
          </div>

          <br /><br />
          <div className="inner">

            <div className="img-pad">

                  <div ref="gridRow" className="row align-top row-pad">
                    <div className="cell cell25 float-left">
                      <Grid color="rgba(246, 141, 46, 1)" num={43} />
                      <p>43% of callers have been referred to a health facility</p>
                    </div>

                    <div className="cell cell25 float-left">
                      <Grid color="rgba(228, 198, 55)" num={57} />
                      <p>57% referrals are for long acting reversible contraceptive methods</p>
                    </div>
                    <div className="cell cell50">
                      {/*}<div className="info-c flex"><div className="info-circle2 flex">1500</div></div>
                      <p>Including 1500 callers who used basic phones tin conunction with the producet as well as a smartphone</p>*/}

                      <div className="cell img-left">
                        <h1 className="large-green img-left"><Number ref="number2" number="3300" /></h1>
                        unique callers<br />&nbsp;
                      </div>
                      <div className="cell img-left">
                        <h1 className="large-orange img-left"><Number ref="number3" number="1731" /></h1>
                        unique AskNivi users with 3,500 questions asked
                      </div>
                    </div>
                  </div>
            </div>
          </div>
          <div className="social-bottom"><Social pageSection="Nivi Mothers in Need" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL + '6.html'} /></div>
        </div>
        <div ref="section11" id="section11">
          <div className="bg"></div>
          <div className="section6-right bg-grey">
            <div className="section6-inner">
              <h1>Gustav Praekelt</h1>
              <h3>A tech leader shaping the future of maternal health solutions</h3>

              <p>Gustav Praekelt likes to joke that he grew up in "Geektown," surrounded by video games on his original Atari and with computer algorithms bouncing around in his head. He might not have been able to anticipate the mobile revolution at the time, but he did cultivate an early appreciation for the systems and structures that underlay his surroundings — whether in music, language or math — and sensed that the future was going to be about connecting these structures together.</p>

              <p>He went to McGill University in Montreal for undergraduate studies in computer science and returned home to South Africa to start a computer graphics and animation studio dubbed Delapse in 1993. That was where he remained until 2001, where he found himself on a street corner in Dar es Salaam, Tanzania, enraptured by the world around him.</p>

              <p>It was the new Africa, a vibrant mix of colors and sounds and fishmongers on their way to market and businessmen in suits and ties headed to the tall buildings that dotted the skyline.</p>

              <p>One thing united all the people around him: mobile phones.</p>

              <p>"I was amazed to see that everybody had a mobile phone in their hand, across the spectrum of life, and that they were all using their phones to text rather than to call," he says. "That was my eureka moment."</p>

              <p>Praekelt returned to his home country of South Africa and founded Praekelt Consulting, which developed leading-edge technologies to help companies leverage the mobile opportunity in the developing world. Everyone from carmakers like VW to beermakers like Guinness to global banks like Barclays lined up for Praekelt’s services.</p>

              <p>His second light bulb moment came when he realized that the same methods and technologies that were helping to drive business through mobile phones could help to distribute vital medical services across African society at extremely low cost.</p>
              
              <p>He created the Praekelt Foundation, which has gone on to become a champion of mobile health services and one of the most visible and impactful foundations on the African continent. To date, Praekelt's projects have reached over 100 million people in over 65 countries. Among its many accomplishments is the launch of an HIV / AIDS service that helps drive adherence to antiretroviral treatment and a pioneering partnership with South Africa’s National Department of Health to create a mobile health service for pregnant moms called MomConnect.</p>

              <p>Rolling out in 2014 with the help of the Praekelt Foundation and 20 other partners from both the private and public sectors, MomConnect provides mothers with a weekly text message containing pertinent information about their baby and their health based on what stage of pregnancy they are in. It also serves as a help desk where moms can ask questions related to maternal and child health and can voice concerns or general feedback about services they received during their pregnancy at public health clinics.</p>

              <p>More than 2 million women have received MomConnect text messages, making it one of the largest government-backed mobile health services in the world, and the largest in Africa. In 2017, MomConnect launched on Facebook’s WhatsApp, allowing the service to integrate into smartphone technology and to include more advanced features like images and audio clips that can be replayed.</p>

              <p>"Mothers become more informed and empowered about their pregnancy, and the ministry of health gets to build a comprehensive registry of pregnancies in the country and receive real-time insights into how clinics are performing," says Praekelt, who recently joined the {this.MERCK} for Mothers Advisory Board. "It’s a win-win."</p>
            </div>
          </div>
          <div className="social-bottom"><Social pageSection="Gustav Praekelt" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL + '7.html'} /></div>
        </div>
        <div id="section12" ref="section12" className="audio-section sumi">
          <a name="audio2"></a>
            <div ref="audio2" className="inner inner-black">
              <h1>Sumiti Saharan of Together For Her</h1>
              <p><em>An Interview with Mark Allen, Director of Strategic Partnerships and Digital Lead at {this.MERCK} for Mothers</em></p>
              <p>Sumiti Saharan of <a href="https://www.togetherforher.com/" target="_blank">Together For Her</a>, a digital platform supported by {this.MERCK} for Mothers that provides underserved mothers with crucial guidance during and after pregnancy, talks about empowering mothers and using their voices to improve the quality of maternal health care in India. </p>
            </div>
              <div className={this.state.playing2 ? "audio audio-open" : "audio"}>
                <div id="waveform2"></div>
              </div>


              {
                this.isIE11 ?
                    <div className="audio-player">
                      <audio controls>
                        <source src={process.env.PUBLIC_URL+"sumi.mp3"} type="audio/mpeg" />
                      </audio>
                    </div>
                    :
                    <div className="play">{this.state.playing2 ? <button onClick={this._play2}>Pause</button> : <button onClick={this._play2}>Play</button>}</div>
              }

              <div className="social-bottom"><Social pageSection="Sumiti Saharan" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} color="black" url={this.BASE_URL + "#audio2"} /></div>
        </div>
        <div ref="section13" id="section13">
          <div className="bg"></div>
          <div ref="section13quote" className="section3-quote"><img src={section13quote} /></div>

          <div ref="section13_left" className="section3-left">
            <div className="section3-inner">
              <h1>Empowering moms with mobile wallets: M-TIBA</h1>

              <p>Peace was born on a pipeline.</p>
              <p>An oil pipeline, to be specific, that delivers refined petroleum from coastal Kenya to the interior of the country. In the capital city of Nairobi, the pipeline passes underneath the Sinai Slum, where more than 15,000 people squat on the Kenya Oil Company's land. </p>

              <p>The houses here are built of shoddy timber and corrugated iron roofs. The threat of eviction is constant. So too is the risk of disease, contamination, crime and robbery. </p>

              <p>This is the world that Peace's mom, Susan Mbula, calls home. </p>

              <p>Mbula had three children before Peace came along. Like most moms in the Sinai Slum, she had neither health savings nor health insurance, so she rarely visited the clinic during her first three pregnancies and couldn't afford vaccines for her children once they were born. </p>

              <p>But when it came to her fourth, things had changed. She was able to pull out her mobile phone and pay for clinical visits from the start of her pregnancy — with small savings that she had set aside over time into a mobile health wallet called M-TIBA. </p>

              <p>When Peace arrived, Mbula was able to afford vaccines. Her sister-in-law chipped in and paid for the six-week follow up appointment straight through the app.</p>

              <p>As Mbula's trust in the app has grown, so too has her confidence that she and her husband will be able to provide quality healthcare to their children as they grow, without jeopardizing their financial wellbeing in the process.</p>

              <p>M-TIBA is the brainchild of Safaricom, the largest telecommunication company in East and Central Africa, best known in Kenya for operating a mobile payment platform called M-PESA that allows users to send each other money through SMS text messages. </p>

              <p>Given the popularity of the service and the health crisis that afflicts Kenya's poor, Safaricom decided to team up with the PharmAccess Foundation to help families direct savings through M-PESA into specialized health wallets. The money in these wallets is only usable at affiliated healthcare providers, whose quality is verified by SafeCare's stepwise certification process. </p>

              <p>As a result, users can trust that the medical care they're receiving is of the highest quality. They also can become more proactive about going to the clinic and are less likely to be blindsided or bankrupted when critical health expenses arise.</p>

              <p>M-TIBA debuted in December 2015 and quickly gained popularity across Kenya, particularly in the country's many slums, of which there are 190 in Nairobi alone. M-TIBA now has 850,000 users and has grown a list of accredited providers that includes more than 450 clinics and hospitals. </p>

              <p>With support from {this.MERCK} for Mothers, the app is expanding its focus to mothers and children. M-TIBA will soon track each step of a pregnant woman's maternal healthcare pathway, thereby monitoring healthcare utilization, costs of care and health outcomes in real-time. </p>
            </div>
          </div>
          <div className="social-bottom"><Social pageSection="M-TIBA" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL + '8.html'} /></div>
        </div>

        <div id="section14" className="almost-full">
          <Parallax bgImage={bg3} strength={100}>
            <div className="section-full flex">
              <div className="inner">
                <h1>Agnes</h1>
                <h3>Software Engineer</h3>
                <p className="quote-single"><img src={quoteSingleWhite} alt="Quote" /></p>
                <p className="italic">M-TIBA has helped me and today my health is better. Anytime I feel sick, I can rush to the hospital because of the money I have saved in my M-TIBA. I appeal to my fellow mothers to join M-TIBA so that we can improve our families' livelihood."</p>
                <p className="quote-single quote-reverse"><img src={quoteSingleWhite} alt="Quote" /></p>
              </div>

            </div>
          </Parallax>
        </div>

        <div ref="section15" id="section15" className="bg-purple top-pad full">
          <div className="inner">
            <Fade><h1 className="h1-main">NOT JUST STATS. LIVES ARE BEING SAVED. </h1></Fade>

            <div className="row">
              <div ref="info15_1" className="cell cell33">
                <div className="mtiba">
                  <h1>M-TIBA</h1>
                  <p>Enabling Africa to leap frog to a mobile economy in only a few years time.</p>
                </div>

                <div className="mtiba">
                  <h2 className="yellow"><Number ref="number4" number="90" />%</h2>
                  <p>of africans now have a mobile phone.</p>
                </div>

                <div className="guy">
                  <img src={guy} />
                  <div ref="progress" className="progress"></div>
                </div>
              </div>
              <div ref="info15_2" className="africa cell cell33 flex">
                <img src={africa} alt="Africa" />
              </div>
              <div ref="info15_3" className="cell cell33">
                <div className="row row-info">
                  <div className="pulse">
                    <div className="pulse-middle"></div>
                    <div className="pulse-middle-ring"></div>
                    <div className="pulse-middle-ring2"></div>
                  </div>
                  Making even the most vulnerable directly accessible
                </div>
                <div className="row row-info">
                  <div className="dollar">$</div>
                  Pre-paid airtime makes using the mobile phone affordable for everybody.
                </div>
                <div className="row row-info">
                  <div className="i">
                    <img src={i} />
                    <div className="i-circle"></div>
                    <div className="i-circle2"></div>
                  </div>
                  Allowing all to quickly exchange information and mobile money.
                </div>

                <h1 className="yellow img-left"><Number ref="number5" number="1000000" /></h1>
                <p className="img-left">lives connected through M-TIBA after launch in June 2016</p>
              </div>
            </div>
          </div>
          <div className="social-bottom"><Social pageSection="M-TIBA Not Just Stats" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL + '9.html'} /></div>
        </div>
        <div id="section16" ref="section16" className="audio-section patty">
          <a name="audio3"></a>
            <div ref="audio3" className="inner inner-black">
              <h1>Patricia Mechael on the Global Digital Health Index</h1>
              <p><em>An Interview with Mark Allen, Director of Strategic Partnerships and Digital Lead at {this.MERCK} for Mothers</em></p>
              <p>As {this.MERCK} for Mothers looks to scale its portfolio, digital initiatives like the recently launched <a href="https://www.digitalhealthindex.org/" target="_blank">Global Digital Health Index (GDHI)</a>, which tracks, monitors and evaluates the use of digital technology for health across countries, will be critical in uncovering the environments that most need aid.  Dr. Mechael, co-founder and policy lead at <a href="http://healthenabled.org/wordpress/" target="_blank">Health Enabled</a>, discusses the importance of the GDHI and how having access to basic digital tools can help solve some of the greatest healthcare challenges in developing countries.</p>

            </div>
            <div className={this.state.playing3 ? "audio audio-open" : "audio"}>
              <div id="waveform3"></div>
            </div>

            {
              this.isIE11 ?
                  <div className="audio-player">
                    <audio controls>
                      <source src={process.env.PUBLIC_URL+"patty.mp3"} type="audio/mpeg" />
                    </audio>
                  </div>
                  :
                  <div className="play">{this.state.playing3 ? <button onClick={this._play3}>Pause</button> : <button onClick={this._play3}>Play</button>}</div>
            }

            <div className="social-bottom"><Social pageSection="Patricia Mechael" mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} color="black" url={this.BASE_URL + "#audio3"} /></div>
        </div>
        <div className="white top-pad">
          <div className="inner">
            <h2>This digital report was brought to you by {this.MERCK} for Mothers. Special thanks to our partners:</h2>

            <Fade right><div className="logo img-left"><img src={logo1} alt="logo" /></div></Fade>
            <Fade left><div className="logo img-right"><img src={logo2} alt="logo" /></div></Fade>
            <Fade right><div className="logo img-left"><img src={logo3} alt="logo" /></div></Fade>
            <Fade left><div className="logo img-right"><img src={logo4} alt="logo" /></div></Fade>
            <Fade right><div className="logo img-left"><img src={logo5} alt="logo" /></div></Fade>
            <Fade left><div className="logo img-right"><img src={logo6} alt="logo" /></div></Fade>
            <Fade right><div className="logo img-left"><img src={logo7} alt="logo" /></div></Fade>
            <Fade left><div className="logo img-right"><img src={logo8} alt="logo" /></div></Fade>
            <Fade right><div className="logo img-left"><img src={logo9} alt="logo" /></div></Fade>
            <Fade left><div className="logo img-right"><img src={logo10} alt="logo" /></div></Fade>
            <Fade right><div className="logo img-left"><img src={logo11} alt="logo" /></div></Fade>
            <Fade left><div className="logo img-right"><img src={logo12} alt="logo" /></div></Fade>

          </div>
        </div>
      </div>
    );
  }

  _scroll() {


    if(window.innerWidth < 800) return;

    const scroll =  document.documentElement.scrollTop || document.body.scrollTop;

    if(!this.state.scrolled && scroll > 100) {
      this.setState({scrolled: true});
    }

    if(scroll < window.innerHeight*2) {
      let pct = scroll / (window.innerHeight*2);

      let t = window.innerHeight/2 * pct;
      this.refs.circle.style.display = 'flex';
      this.refs.circle.style.transform = 'translateY('+t+'px)';
    } else {
      if(this.refs.circle.style.display !== 'none') {
        this.refs.circle.style.display = 'none';
      }

    }

    if(
      scroll > this._fromTop(this.refs.section2)-window.innerHeight
      && scroll < this._fromTop(this.refs.section2) + this.refs.section2.offsetHeight
    ) {
      var pct = 1- ((this._fromTop(this.refs.section2)-scroll) / window.innerHeight);
      if(pct > 1) {
        pct = 1;
      }
      //console.log(pct);

      //pct*=1.2;

      var n = -100*(1-pct);

      this.refs.two.style.transform = 'translateX('+n+'%)';

      this.refs.rest1.style.opacity = pct;
      this.refs.rest2.style.opacity = pct;
      this.refs.rest3.style.opacity = pct;
      this.refs.rest4.style.opacity = pct;
      this.refs.rest5.style.opacity = pct;
    }

    if(scroll > this._fromTop(this.refs.expanded)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.expanded)-scroll) / window.innerHeight);
      if(pct > 1) {
        pct = 1;
      }

      let n = 1+(0.3*pct);
      this.refs.expanded.style.transform = 'scale('+n+')';
    }

    //SECTION 3
    if(scroll >= this._fromTop(this.refs.section3)
      && scroll < this._fromTop(this.refs.section3) + this.refs.section3.offsetHeight
    ) {
      if(scroll >= this._fromTop(this.refs.section3) + this.refs.section3.offsetHeight - window.innerHeight) {
        this.refs.section3.className = 'absolute-bottom';
      } else {
        this.refs.section3.className = 'fixed';
      }

      if(scroll >= this._fromTop(this.refs.section3) + this.refs.section3_left.offsetHeight - window.innerHeight) {
        if(scroll > this._fromTop(this.refs.section3) + this.refs.section3.offsetHeight - window.innerHeight) {
          this.refs.section3_left.style.top = Math.ceil(this.refs.section3.offsetHeight-this.refs.section3_left.offsetHeight)+'px';
        } else {
          let pixels = (this._fromTop(this.refs.section3) + this.refs.section3_left.offsetHeight - window.innerHeight) - scroll;
          pixels *= -1;
          this.refs.section3_left.style.top = pixels+'px';
        }

        this.refs.section3_left.style.filter = 'blur(2px)';

      } else {
        this.refs.section3_left.style.top = '0px';
        this.refs.section3_left.style.filter = '';
      }

    } else {
      this.refs.section3.className = '';
    }


    if(
      scroll > this._fromTop(this.refs.section5)-window.innerHeight
      && scroll < this._fromTop(this.refs.section5) + this.refs.section5.offsetHeight
    ) {
      let pct = 1- ((this._fromTop(this.refs.section5)-scroll) / this.refs.section5.offsetHeight);
      if(pct > 1) {
        pct = 1;
      }
      let n = 100*(1-pct) ;

      this.refs.info0.style.opacity = pct; //'translateX('+n+'%)';
      this.refs.info1.style.transform = 'translateX('+n+'%)';
      if(n < 1 && !this.count && !this.number1) {
        this.count = true;
        this.refs.countUp.start();

        this.number1 = true;
        this.refs.cloud.start();
      }

      this.refs.info3.style.transform = 'translateX('+n*0.4+'%)';

      let pct2 = (1- ((this._fromTop(this.refs.section5)+this.refs.section5.offsetHeight/2-scroll) / (this.refs.section5.offsetHeight/2)));
      if(pct2 > 0) {
        var color2 = 'C1A6B5';
        var color1 = '73C7AE';

        var color4 = 'C1A6B5';
        var color3 = '00877C';
        var ratio = pct2;
        var hex = function(x) {
            x = x.toString(16);
            return (x.length == 1) ? '0' + x : x;
        };

        var r = Math.ceil(parseInt(color1.substring(0,2), 16) * ratio + parseInt(color2.substring(0,2), 16) * (1-ratio));
        var g = Math.ceil(parseInt(color1.substring(2,4), 16) * ratio + parseInt(color2.substring(2,4), 16) * (1-ratio));
        var b = Math.ceil(parseInt(color1.substring(4,6), 16) * ratio + parseInt(color2.substring(4,6), 16) * (1-ratio));


        var r2 = Math.ceil(parseInt(color3.substring(0,2), 16) * ratio + parseInt(color4.substring(0,2), 16) * (1-ratio));
        var g2 = Math.ceil(parseInt(color3.substring(2,4), 16) * ratio + parseInt(color4.substring(2,4), 16) * (1-ratio));
        var b2 = Math.ceil(parseInt(color3.substring(4,6), 16) * ratio + parseInt(color4.substring(4,6), 16) * (1-ratio));

        var middle = hex(r) + hex(g) + hex(b);
        var middle2 = hex(r2) + hex(g2) + hex(b2);
        //console.log(middle + pct2);
        let selects = document.getElementsByClassName("light-green");
        for(let i =0;i<selects.length;i++){
          // selects[i].style.opacity = pct2;
          selects[i].style.fill = '#'+middle;

        }

        let selects2 = document.getElementsByClassName("dark-green");
        for(let i =0;i<selects2.length;i++){
        //   selects2[i].style.opacity = pct2;

           selects2[i].style.fill = '#'+middle2;
        }
      }

    }


    //SECTION 6
    if(
      scroll >= this._fromTop(this.refs.section6)
      && scroll < this._fromTop(this.refs.section6) + this.refs.section6.offsetHeight
    ) {
      if(scroll >= this._fromTop(this.refs.section6) + this.refs.section6.offsetHeight - window.innerHeight) {
        this.refs.section6.className = 'absolute-bottom';
      } else {
        this.refs.section6.className = 'fixed';
      }

    } else {
      this.refs.section6.className = '';
    }


    if(
      scroll > this._fromTop(this.refs.section6)-window.innerHeight
      && scroll < this._fromTop(this.refs.section6) + this.refs.section6.offsetHeight
    ) {
      let pct = 1- ((this._fromTop(this.refs.section6)-scroll) / window.innerHeight);
      if(pct > 1) {
        pct = 1;
      }
      let n = -100*(1-pct) ;

      this.refs.pink.style.transform = 'translateX('+n*0.5+'%)';
    }

    //SECTION7 Audio
    if(
      scroll > this._fromTop(this.refs.section7)-window.innerHeight
      && scroll < this._fromTop(this.refs.section7) + this.refs.section7.offsetHeight
    ) {
      let pct = 1- ((this._fromTop(this.refs.section7)-scroll) / window.innerHeight);
      pct *= 1.2;
      if(pct > 1) {
        pct = 1;
      }
      let n = 100*(1-pct) ;

      this.refs.audio1.style.transform = 'translateX('+n+'%)';
    }


    //SECTION 8
    if(scroll >= this._fromTop(this.refs.section8)
      && scroll < this._fromTop(this.refs.section8) + this.refs.section8.offsetHeight
    ) {
      if(scroll >= this._fromTop(this.refs.section8) + this.refs.section8.offsetHeight - window.innerHeight) {
        this.refs.section8.className = 'absolute-bottom';
      } else {
        this.refs.section8.className = 'fixed';
      }

      if(scroll >= this._fromTop(this.refs.section8) + this.refs.section8_left.offsetHeight - window.innerHeight) {
        if(scroll > this._fromTop(this.refs.section8) + this.refs.section8.offsetHeight - window.innerHeight) {
          this.refs.section8_left.style.top = Math.ceil(this.refs.section8.offsetHeight-this.refs.section8_left.offsetHeight)+'px';
        } else {
          let pixels = (this._fromTop(this.refs.section8) + this.refs.section8_left.offsetHeight - window.innerHeight) - scroll;
          pixels *= -1;
          this.refs.section8_left.style.top = pixels+'px';
        }

        this.refs.section8_left.style.filter = 'blur(2px)';

      } else {
        this.refs.section8_left.style.top = '0px';
        this.refs.section8_left.style.filter = '';
      }

    } else {
      this.refs.section8.className = '';
    }



    if(
      scroll > this._fromTop(this.refs.section10)-window.innerHeight
      && scroll < this._fromTop(this.refs.section10) + this.refs.section10.offsetHeight
    ) {
      let pct = 1- ((this._fromTop(this.refs.section10)-scroll) / this.refs.section10.offsetHeight);
      if(pct > 1 ) {
        pct = 1;

        this.number2 = true;
        this.refs.number2.start();

        this.number3 = true;
        this.refs.number3.start();
      }
      let n = 100*(1-pct) ;

      this.refs.fourth1.style.transform = 'translateY('+n*0.4+'%)';
      this.refs.fourth2.style.transform = 'translateY('+n*0.6+'%)';
      this.refs.fourth3.style.transform = 'translateY('+n*0.8+'%)';
      this.refs.fourth4.style.transform = 'translateY('+n+'%)';


      this.refs.gridRow.style.transform = 'translateX('+n+'%)';

    }


    //SECTION 11
    if(
      scroll >= this._fromTop(this.refs.section11)
      && scroll < this._fromTop(this.refs.section11) + this.refs.section11.offsetHeight
    ) {
      if(scroll >= this._fromTop(this.refs.section11) + this.refs.section11.offsetHeight - window.innerHeight) {
        this.refs.section11.className = 'absolute-bottom';
      } else {
        this.refs.section11.className = 'fixed';
      }

    } else {
      this.refs.section11.className = '';
    }


    //SECTION12 Audio
    if(
      scroll > this._fromTop(this.refs.section12)-window.innerHeight
      && scroll < this._fromTop(this.refs.section12) + this.refs.section12.offsetHeight
    ) {
      let pct = 1- ((this._fromTop(this.refs.section12)-scroll) / window.innerHeight);
      pct *= 1.2;
      if(pct > 1) {
        pct = 1;
      }
      let n = 100*(1-pct) ;

      this.refs.audio2.style.transform = 'translateX('+n+'%)';
    }

    //SECTION 13
    if(
      scroll >= this._fromTop(this.refs.section13)
      && scroll < this._fromTop(this.refs.section13) + this.refs.section13.offsetHeight
    ) {
      if(scroll >= this._fromTop(this.refs.section13) + this.refs.section13.offsetHeight - window.innerHeight) {
        this.refs.section13.className = 'absolute-bottom';
      } else {
        this.refs.section13.className = 'fixed';
      }

      if(scroll >= this._fromTop(this.refs.section13) + this.refs.section13_left.offsetHeight - window.innerHeight) {
        if(scroll > this._fromTop(this.refs.section13) + this.refs.section13.offsetHeight - window.innerHeight) {
          this.refs.section8_left.style.top = Math.ceil(this.refs.section13.offsetHeight-this.refs.section13_left.offsetHeight)+'px';
        } else {
          let pixels = (this._fromTop(this.refs.section13) + this.refs.section13_left.offsetHeight - window.innerHeight) - scroll;
          pixels *= -1;
          this.refs.section13_left.style.top = pixels+'px';
        }

        this.refs.section13_left.style.filter = 'blur(2px)';

      } else {
        this.refs.section13_left.style.top = '0px';
        this.refs.section13_left.style.filter = '';
      }

    } else {
      this.refs.section13.className = '';
    }


    if(
      scroll > this._fromTop(this.refs.section15)-window.innerHeight
      && scroll < this._fromTop(this.refs.section15) + this.refs.section15.offsetHeight
    ) {
      let pct = 1- ((this._fromTop(this.refs.section15)-scroll) / window.innerHeight);
      if(pct > 1) {
        pct = 1;
      }
      let n = 100*(1-pct);

      this.refs.info15_1.style.transform = 'translateY('+n*0.3+'%)';
      this.refs.info15_2.style.transform = 'translateY('+n*0.6+'%)';
      this.refs.info15_3.style.transform = 'translateY('+n+'%)';


      let pct2 = 1- ((this._fromTop(this.refs.section15)-(scroll-window.innerHeight*0.1)) / window.innerHeight);
      if(pct2 > 1 && !this.number4 && !this.number5) {
        pct2 = 1;

        this.number4 = true;
        this.refs.number4.start();

        this.number5 = true;
        this.refs.number5.start();
      }
      let n2 = 100*(1-pct2);

      if(n2 < 10) {
        n2 = 10;
      }

      this.refs.progress.style.width = (100-n2)+'%';
    }

    //SECTION16 Audio
    if(
      scroll > this._fromTop(this.refs.section16)-window.innerHeight
      && scroll < this._fromTop(this.refs.section16) + this.refs.section16.offsetHeight
    ) {
      let pct = 1- ((this._fromTop(this.refs.section16)-scroll) / window.innerHeight);
      pct *= 1.2;

      if(pct > 1) {
        pct = 1;
      }
      let n = 100*(1-pct);

      this.refs.audio3.style.transform = 'translateX('+n+'%)';
    }

  }

  _fromTop( elem ) {
    var location = 0;
    if(elem) {
      if (elem.offsetParent) {
          do {
              location += elem.offsetTop;
              if(elem) {
                elem = elem.offsetParent;
              } else {
                elem = null;
              }

          } while (elem);
      }
    }

    return location >= 0 ? location : 0;
  }

  _play() {
    if(this.state.playing) {
      this.wavesurfer.pause();
      this.setState({playing: false});
    } else {
      this.wavesurfer.play();
      this.setState({playing: true});
      window.gtag('event','play',{'event_category':'Audio','event_label':'Linda Bartlett'});
    }
  }

  _play2() {
    if(this.state.playing2) {
      this.wavesurfer2.pause();
      this.setState({playing2: false});
    } else {
      this.wavesurfer2.play();
      this.setState({playing2: true});
      window.gtag('event','play',{'event_category':'Audio','event_label':'Sumiti Saharan'});
    }

  }

  _play3() {
    if(this.state.playing3) {
      this.wavesurfer3.pause();
      this.setState({playing3: false});
    } else {
      this.wavesurfer3.play();
      this.setState({playing3: true});
      window.gtag('event','play',{'event_category':'Audio','event_label':'Patricia Mechael'});
    }

  }

  _resize() {
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js